module.exports = __webpack_public_path__ + "38861cba61c66739c1452c3a71e39852.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.ttf
// module id = 379
// module chunks = 1